module.exports = __webpack_public_path__ + "img/flanders-histogram.83ec88d2.svg";